import { Component, Inject, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { showAnimation } from 'src/animations';
import { plainMailToHTML } from 'src/app/globals';
import { EMailAudit } from '../../../classes';
import { IMailProviderService, MAIL_PROVIDER_SERVICE } from '../../../interfaces';
import { MailService } from '../../../services/mail.service';

@Component({
  selector: 'app-mail-widget',
  templateUrl: './mail-widget.component.html',
  styleUrls: ['./mail-widget.component.css'],
  animations: [ showAnimation ]
})
export class MailWidgetComponent implements OnInit {

  @Input() toggled: boolean = false;

  currentMailId: string = null;
  private _mailChanged = new Subject<Object>();

  mailBody: string;

  constructor(
    @Inject(MAIL_PROVIDER_SERVICE) public service: IMailProviderService,
    private _mailService: MailService
  ) { }

  ngOnInit(): void { }

  setMail(eMail: EMailAudit) {
    this.currentMailId = eMail.messageId;
    if (eMail.htmlBody) {
      this._mailService.resolveEMailCids(eMail, this._mailChanged.asObservable()).subscribe(() => this.mailBody = eMail.htmlBody);
    } else this.mailBody = plainMailToHTML(eMail.body);
  }

}
